var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!!_vm.post)?_c('div',{attrs:{"id":"main"}},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.post.content)}})]):_c('div',[_vm._v(" Kein Post verfügbar ")])}
var staticRenderFns = []

export { render, staticRenderFns }